module.exports = __webpack_public_path__ + "static/media/kmg.3601558e.png";